<div class="container-fluid">
<div class="welcome-section mb-4 fade-in d-none d-md-block">

    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h2 class="fw-bold">Inventory Dashboard</h2>
        <h4 class="welcome-text">Check your inventory levels and manage your stock</h4>
      </div>
      <div class="d-flex align-items-center gap-3">
        <button style="border: 1px solid #ccc; border-radius: 5px;"
          class="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2" (click)="toggleTableLayout()"
          [title]="isTablesStacked ? 'Switch to side-by-side view' : 'Switch to stacked view'">
          <i class="bi" [ngClass]="isTablesStacked ? 'bi-layout-split' : 'bi-layout-three-columns'"></i>
          <span>{{ isTablesStacked ? 'Side by Side' : 'Stack Tables' }}</span>
        </button>

        <div class="text-end">
          <small class="text-muted d-block">Current User:</small>
          <h6 class="mb-0">{{fullName}}</h6>
          <small class="text-muted d-block">{{tenantName}}</small>
        </div>
      </div>
    </div>
  </div>

  <!-- MOBILE VIEW -->
  <app-mobile-inventory-view class="d-md-none"
    [totalRawMaterials]="totalRawMaterials"
    [totalFinishedGoods]="totalFinishedGoods"
    [lowStockItems]="lowStockItems"
    [totalRawMaterialValue]="totalRawMaterialValue"
    [totalProductValueFromBOM]="totalProductValueFromBOM"
    [rawMaterials]="rawMaterials"
    [filteredFinishedGoods]="filteredFinishedGoods"
    [categories]="categories"
    [unitsOfMeasure]="uomList"
    [suppliers]="suppliers"
    [stackedBarData]="stackedBarData"
    [baseColors]="baseColors"
    [categoryLabels]="categoryLabels"
    [categoryData]="categoryData"
    [ItemsPerPage]="ItemsPerPage"
    [filters]="filters"
    [selectedFilter]="selectedFilter"
    [currentPage]="currentPage"
    [totalPages]="totalPages"
    [totalItemsCount]="totalItemsCount"
    [goToPage]="goToPage"
    [onPageSizeChange]="onPageSizeChange"
    (saveItemMobile)="saveItemMobile($event)"
    (deleteItemMobile)="deleteItemMobile($event)"
    (createCategoryMobile)="createCategoryMobile($event)"
    (filterChange)="onFilterChange($event)"
    (pageChange)="onPageChange($event)"
    (downloadTemplateMobile)="downloadTemplate()"
    (downloadFinishedTemplateMobile)="downloadFinishedGoodTemplate()"
    (importMobile)="onFileSelected($event)">
  </app-mobile-inventory-view>

  <div class="dashboard-cards fade-in d-none d-md-flex">
    <!-- Total Stock Items Card -->
    <!-- <div class="metric-card main" [ngClass]="{'positive': stockItemsTrend > 0, 'negative': stockItemsTrend < 0}"> -->
      <div class="metric-card main" style="width: 50%;">
        <div class="card-content">
          <div class="icon-container main">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20 7L12 3L4 7L12 11L20 7Z"
                stroke="#007A8F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M4 17L12 21L20 17"
                stroke="#007A8F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M4 7V17"
                stroke="#007A8F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              <path
                d="M20 7V17"
                stroke="#007A8F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            </div>
          <div class="metric-info">
            <div class="d-flex flex-row flex-grow-1 justify-content-evenly" style="align-items: center;">

              <div class="d-flex flex-column">
                <div class="d-flex align-items-center gap-2 mb-2">
                  <p class="metric-label">Total Raw Materials</p>
                </div>
                <span class="fw-bold text-center" style="font-size: 1.4rem; ">
                  {{ totalRawMaterials }}
                </span>
              </div>

              <div class="vr mx-2" style="height: 50px; opacity: 0.3; background-color: #007a8f"></div>

              <div class="d-flex flex-column">
                <div class="d-flex align-items-center gap-2 mb-2">
                  <p class="metric-label">Total Products</p>
                </div>
                <span class="fw-bold text-center" style="font-size: 1.4rem; ">
                  {{ totalFinishedGoods }}
                </span>
              </div>

            </div>
          </div>
        </div>
      </div>


    <!-- Low Stock Items Card -->
    <div class="metric-card warning" style="width: 45%;" [class.pulse]="lowStockItems > 0 && showLowStockPopup">
      <div class="card-content">
        <div class="icon-container warning">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 16H12.01M12 8V12M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
              stroke="#6C7A3E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>

        <div class="metric-info">
          <div class="d-flex flex-row flex-grow-1 justify-content-center" style="align-items: center;">

            <div class="d-flex flex-column">
              <div class="d-flex align-items-center gap-2 mb-2 ">
                <p class="metric-label">Low Raw Material Items</p>
              </div>
              <span class="fw-bold text-center" style="font-size: 1.4rem; ">
                {{ lowStockItems }}
              </span>
            </div>

          </div>
        </div>
      </div>
    </div>




    <div class="metric-card success">
      <div class="card-content">

                  <div class="icon-container success">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 15V17M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
              stroke="#B0213C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M9.5 10C9.5 8.61929 10.6193 7.5 12 7.5C13.3807 7.5 14.5 8.61929 14.5 10C14.5 11.3807 13.3807 12.5 12 12.5C10.6193 12.5 9.5 11.3807 9.5 10Z"
              stroke="#B0213C" stroke-width="2" />
          </svg>

          </div>
        <div class="metric-info">
          <div class="d-flex flex-row flex-grow-1 justify-content-evenly" style="align-items: center;">

            <div class="d-flex flex-column" style="padding-right: 1.5rem">
              <div class="d-flex align-items-center gap-2 mb-2">
                <p class="metric-label">Total Raw Material Value</p>
              </div>
              <span class="fw-bold text-center" style="font-size: 1.4rem; ">
                {{ totalRawMaterialValue | currency:'ZAR':'symbol':'1.2-2' }}
              </span>
            </div>

            <div class="vr mx-2" style="height: 50px; opacity: 0.3; background-color: #007a8f"></div>

            <div class="d-flex flex-column" style="padding-left: 1.5rem">
              <div class="d-flex align-items-center gap-2 mb-2">
                <p class="metric-label">Total Product Value</p>
              </div>
              <span class="fw-bold text-center" style="font-size: 1.4rem; ">
                {{ totalProductValueFromBOM | currency:'ZAR':'symbol':'1.2-2' }}
              </span>
            </div>

            <div class="vr mx-2" style="height: 50px; opacity: 0.3; background-color: #007a8f"></div>

            <div class="d-flex flex-column" style="padding-left: 1.5rem">
              <div class="d-flex align-items-center gap-2 mb-2">
                <p class="metric-label">All Total</p>
              </div>
              <span class="fw-bold text-center" style="font-size: 1.4rem; ">
                {{ totalRawMaterialValue + totalProductValueFromBOM | currency:'ZAR':'symbol':'1.2-2' }}
              </span>
            </div>

          </div>
        </div>
      </div>
    </div>
    <!-- Stock Categories Card -->
  </div>

  <!-- Inventory Cards -->
  <div class="dashboard-cards fade-in" [class.tables-stacked]="isTablesStacked">
    <!-- Raw Materials Card -->
    <div class="metric-card inv-raw-section" style="flex-grow: 1; max-height: 120vh; display: flex; flex-direction: column">
      <div class="card-body" style="display: flex; flex-direction: column; flex: 1; min-height: 0">
        <div class="CardHeader">
          <div class="d-flex align-items-center">
            <div class="chart-icon-container me-3">
              <i class="bi bi-box-seam"></i>
            </div>
            <span style="display: flex; align-items: center;">
              <h3 style="margin-bottom: 5px; ">Raw Materials</h3>
              <app-tooltip [tooltipId]="'IngredientsMaterial'">
                <i icon class="bi bi-info-circle"></i>
                <div content>
                  <p>
                    <strong>
                      Think of raw materials as the items you need to make something.
                      <br>
                      <br>
                      NB:
                      <br>
                      Remember to update unit cost if the suppliers changed their pricing.

                    </strong>
                  </p>
                </div>
              </app-tooltip>
            </span>

          </div>
          <div role="group" aria-label="Raw Material Actions" style="display: flex; align-items: center; gap: 4px;">
            <!-- Download Button -->
            <button *ngIf="userRole === 'Admin User' || userRole === 'Factory User'" type="button"
              class="btn btn-teal-gradient btn-sm text" (click)="downloadTemplate()" [disabled]="isImporting">
              <i class="bi bi-download"></i>
              Download Template
            </button>

            <!-- Set Reorder Levels Button -->
            <button *ngIf="zeroReorderItems.length > 0" type="button"
              class="btn btn-warning btn-sm text" (click)="showReorderPrompt = true">
              <i class="bi bi-exclamation-triangle"></i>
              Set Reorder Levels ({{ zeroReorderItems.length }})
            </button>

            <!-- Hidden File Input -->
            <input #fileInput type="file" accept=".xlsx" (change)="onFileSelected($event)" hidden>

            <!-- Import Button -->
            <button *ngIf="userRole === 'Admin User' || userRole === 'Factory User'" type="button"
              class="btn btn-teal-gradient btn-sm text d-flex align-items-center gap-1" (click)="fileInput.click()"
              [disabled]="isImporting">
              <i class="bi bi-upload"></i>
              Import
            </button>

            <!-- Add Button -->
            <button *ngIf="userRole === 'Admin User' || userRole === 'Factory User'" type="button"
              class="btn btn-teal-gradient btn-sm text d-flex align-items-center gap-1" (click)="openAddOption(); isFinishedGood = false">
              <i class="bi bi-plus"></i>
              Add
            </button>
          </div>
          <!-- Search Bar for Raw Materials -->

        </div>
        <div class="d-flex align-items-center gap-2 mb-3" style="padding-top: 5px;">
          <div class="input-group" style="min-width: 30%">
            <span class="input-group-text"><i class="bi bi-search"></i></span>
            <input type="text" class="form-control" placeholder="Search Raw Materials..."
              [(ngModel)]="rawMaterialsSearchTerm" (input)="filterRawMaterials()" />
          </div>

          <div class="filter-button-container">
            <button class="btn btn-teal-gradient btn-sm" [class.btn-teal-gradient]="!isFilterPanelOpenRawMaterials"
              [class.btn-grey-gradient]="isFilterPanelOpenRawMaterials" type="button"
              (click)="toggleFilterPanelRawMaterials()">
              <i class="bi bi-funnel"></i>
              {{ !isFilterPanelOpenRawMaterials ? 'Show Filters' : 'Hide Filters' }}
            </button>
          </div>
        </div>

        <div class="filter-panel-container">
          <div class="filter-panel" [class.visible]="isFilterPanelOpenRawMaterials">
            <div class="d-flex align-items-center">
              <select class="form-select form-select-sm" [(ngModel)]="selectedCategoryFilter"
                (change)="filterRawMaterials()">
                <option [ngValue]="null">All Categories</option>
                <option *ngFor="let category of categories" [ngValue]="category.categoryId">
                  {{ category.categoryName }}
                </option>
              </select>
            </div>

            <div class="d-flex align-items-center">
              <select class="form-select form-select-sm" [(ngModel)]="selectedUOMFilter"
                (change)="filterRawMaterials();">
                <option [ngValue]="null">All Units of Measure</option>
                <option *ngFor="let uom of uomList" [ngValue]="uom.uomid">
                  {{ uom.uomName }}
                </option>
              </select>
            </div>

            <div class="d-flex align-items-center">
              <div class="d-flex align-items-center gap-2 w-100">
                <span class="text-muted me-2">Stock</span>
                <div class="btn-group segmented" role="group" aria-label="Stock filter">
                  <!-- All -->
                  <input type="radio" class="btn-check" name="rmStock" id="rm-stock-all" autocomplete="off"
                         [checked]="!showLowStockOnly && !showNonLowStockOnly"
                         (change)="showLowStockOnly=false; showNonLowStockOnly=false; filterRawMaterials()">
                  <label class="btn segmented-btn"
                         [class.btn-teal-gradient]="!showLowStockOnly && !showNonLowStockOnly"
                         [class.btn-grey-gradient]="showLowStockOnly || showNonLowStockOnly"
                         for="rm-stock-all">
                    <i class="bi bi-collection me-1"></i> All
                  </label>

                  <!-- Low stock only -->
                  <input type="radio" class="btn-check" name="rmStock" id="rm-stock-low" autocomplete="off"
                         [checked]="showLowStockOnly && !showNonLowStockOnly"
                         (change)="showLowStockOnly=true; showNonLowStockOnly=false; filterRawMaterials()">
                  <label class="btn segmented-btn"
                          [class.btn-teal-gradient]="showLowStockOnly && !showNonLowStockOnly"
                          [class.btn-grey-gradient]="!showLowStockOnly || showNonLowStockOnly"
                          for="rm-stock-low">
                    <i class="bi bi-exclamation-triangle me-1"></i> Low
                  </label>

                  <!-- In stock only -->
                  <input type="radio" class="btn-check" name="rmStock" id="rm-stock-in" autocomplete="off"
                         [checked]="!showLowStockOnly && showNonLowStockOnly"
                         (change)="showLowStockOnly=false; showNonLowStockOnly=true; filterRawMaterials()">
                  <label class="btn segmented-btn"
                          [class.btn-teal-gradient]="!showLowStockOnly && showNonLowStockOnly"
                          [class.btn-grey-gradient]="showLowStockOnly || !showNonLowStockOnly"
                          for="rm-stock-in">
                    <i class="bi bi-check-circle me-1"></i> In stock
                  </label>
                </div>
              </div>
             </div>
            <div class="d-flex align-items-center mt-2">
              <div class="d-flex align-items-center gap-2 w-100 justify-content-end">
                <span class="text-muted me-1">Rows per page</span>
                <select class="form-select form-select-sm" style="max-width: 90px"
                        [(ngModel)]="rawMaterialsPageSize"
                        (ngModelChange)="rawMaterialsCurrentPage = 1">
                  <option [ngValue]="15">15</option>
                  <option [ngValue]="25">25</option>
                  <option [ngValue]="50">50</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="table-responsive scrollable-content" style="flex-grow: 1; min-height: 0; overflow-y: auto">


          <div *ngIf="rawMaterials.length === 0" class="empty-state p-4 text-center">
            <div class="empty-state-icon mb-3">
              <i class="bi bi-box-seam" style="font-size: 2.5rem; color: #6c757d;"></i>
            </div>
            <h5 class="mb-2">No Raw Materials</h5>
            <p class="text-muted mb-0">Add your first Raw Material to get started</p>
            <button class="btn btn-primary mt-3" (click)="openAddOption();isFinishedGood=false">
              <i class="bi bi-plus-circle me-1"></i> Add Raw Material
            </button>
          </div>
          <!-- Desktop table for raw materials -->
          <table class="table table-hover align-middle mb-0 d-none d-md-table" *ngIf="rawMaterials.length > 0">
            <thead class="table-header rounded-2">
              <tr>
                <th class=" fw-bold" style="cursor: pointer" (click)="sortBy('itemCode')">
                  SKU
                  <i class="bi ms-1" [ngClass]="{
                        'bi-caret-down-fill':
                        sortColumn !== 'itemCode' ||
                          (sortColumn === 'itemCode' &&
                            sortDirection === 'desc'),
                        'bi-caret-up-fill':
                          sortColumn === 'itemCode' &&
                          sortDirection === 'asc'
                      }"></i>
                </th>

                <th style="cursor: pointer" class="fw-bold" (click)="sortBy('itemName')">
                  Item Name
                  <i class="bi ms-1" [ngClass]="{
                        'bi-caret-down-fill':
                          sortColumn !== 'itemName' ||
                          (sortColumn === 'itemName' &&
                            sortDirection === 'desc'),
                        'bi-caret-up-fill':
                          sortColumn === 'itemName' && sortDirection === 'asc'
                      }"></i>
                </th>
                <th style="cursor: pointer" class="fw-bold" (click)="sortBy('purchaseUOMID')">
                  UOM
                  <i class="bi ms-1" [ngClass]="{
                        'bi-caret-down-fill':
                          sortColumn !== 'purchaseUOMID' ||
                          (sortColumn === 'purchaseUOMID' &&
                            sortDirection === 'desc'),
                        'bi-caret-up-fill':
                          sortColumn === 'purchaseUOMID' && sortDirection === 'asc'
                      }"></i>
                </th>
                <th style="cursor: pointer; min-width: 125px; width: 125px;" class="fw-bold"
                  (click)="sortBy('CategoryName')">
                  Category
                  <i class="bi ms-1" [ngClass]="{
                        'bi-caret-down-fill':
                          sortColumn !== 'CategoryName' ||
                          (sortColumn === 'CategoryName' &&
                            sortDirection === 'desc'),
                        'bi-caret-up-fill':
                          sortColumn === 'CategoryName' &&
                          sortDirection === 'asc'
                      }"></i>
                </th>
                <th style="cursor: default" class="fw-bold">
                  Quantity
                </th>
                <th style="cursor: default" class="fw-bold">
                  Reorder At
                </th>

                <th style="cursor: pointer" class="fw-bold" (click)="sortBy('unitCost')">
                  Unit Cost
                  <i class="bi ms-1" [ngClass]="{
                        'bi-caret-down-fill':
                          sortColumn !== 'unitCost' ||
                          (sortColumn === 'unitCost' &&
                            sortDirection === 'desc'),
                        'bi-caret-up-fill':
                          sortColumn === 'unitCost' && sortDirection === 'asc'
                      }"></i>
                </th>
                <th *ngIf="userRole === 'Admin User'" style="cursor: default" class="fw-bold text-center">
                  Actions
                </th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let item of rawMaterialsPaged">
                <td>{{ item.itemCode }}</td>
                <td class="fw-semibold">{{ item.itemName }}</td>
                <td>{{ getUOMName(item.purchaseUOMID) }}</td>
                <td>
                  <span class="category-badge" [style.background-color]="getCategoryColor(item.CategoryName)">
                    {{ item.CategoryName }}
                  </span>
                </td>
                <td>
                  <span class="quantity-badge" [ngClass]="{
                    'badge-warning':
                    (item.quantity ?? 0) === (item.lowStockThreshold ?? 0),
                        'badge-success':
                        (item.quantity ?? 0) > (item.lowStockThreshold ?? 0),
                        'badge-danger':
                        (item.quantity ?? 0) < (item.lowStockThreshold ?? 0)
                      }">
                    {{ item.quantity | number: '1.2-2' }}
                  </span>
                </td>
                <td>
                  <span class="quantity-badge badge-neutral">{{ item.lowStockThreshold }}</span>
                </td>
                <!-- <td>{{ item.unitCost | currency : "ZAR" : 'symbol' : '1.2-2' }}</td> -->
                 <td>{{ item.purchasePrice / item.purchaseQuantity | currency : "ZAR" : 'symbol' : '1.2-2' }}</td>
                <td *ngIf="userRole === 'Admin User'" class="text-nowrap">
                  <button *ngIf="userRole === 'Admin User'" class="btn-outline-primary" (click)="editItem(item)">
                    <i class="bi bi-pencil-square"></i>
                  </button>
                  <button *ngIf="userRole === 'Admin User'" class="btn-outline-primary danger"
                    (click)="selectedItem = item; showDeleteModal = true">
                    <i class="bi bi-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>


        </div>
                        <nav *ngIf="rawMaterialsTotalPages > 1" class="mt-2" aria-label="Raw materials pagination">
            <ul class="pagination pagination-sm mb-0 justify-content-end">
              <li class="page-item" [class.disabled]="rawMaterialsCurrentPage === 1">
                <button class="page-link" type="button" (click)="changeRawMaterialsPage(rawMaterialsCurrentPage - 1)" aria-label="Previous">
                  <span aria-hidden="true">&laquo;</span>
                </button>
              </li>
              <li class="page-item" *ngFor="let page of rawMaterialsPages" [class.active]="page === rawMaterialsCurrentPage">
                <button class="page-link" type="button" (click)="changeRawMaterialsPage(page)">{{ page }}</button>
              </li>
              <li class="page-item" [class.disabled]="rawMaterialsCurrentPage === rawMaterialsTotalPages">
                <button class="page-link" type="button" (click)="changeRawMaterialsPage(rawMaterialsCurrentPage + 1)" aria-label="Next">
                  <span aria-hidden="true">&raquo;</span>
                </button>
              </li>
            </ul>
          </nav>
      </div>

    </div>

    <!-- Finished Goods Card -->
    <div class="metric-card inv-products-section" style="flex-grow: 1; max-height: 120vh; display: flex; flex-direction: column">
      <div class="card-body" style="display: flex; flex-direction: column; flex: 1; min-height: 0">
        <div class="CardHeader">
          <div class="d-flex align-items-center">
            <div class="chart-icon-container me-3">
              <i class="bi bi-bag-check"></i>
            </div>

            <span style="display: flex; align-items: center;">
              <h3 style="margin-bottom: 5px; ">Products</h3>
              <app-tooltip [tooltipId]="'stock-goods'">F
                <i icon class="bi bi-info-circle"></i>
                <div content>
                  <p>
                    <strong>
                      Products are things that are made or offered to people to buy or use. They can be physical items
                      you can touch or services that you do for someone. </strong>
                  </p>
                </div>
              </app-tooltip>
            </span>



          </div>
          <div role="group" aria-label="Raw Material Actions" style="display: flex; align-items: center; gap: 4px;">
            <!-- Download Button -->
            <button *ngIf="userRole === 'Admin User' || userRole === 'Factory User'" type="button"
              class="btn btn-teal-gradient btn-sm text" (click)="downloadFinishedGoodTemplate()"
              [disabled]="isImporting">
              <i class="bi bi-download"></i>
              Download Template
            </button>

            <!-- Hidden File Input -->
            <input #fileInput type="file" accept=".xlsx" (change)="onFileSelected($event)" hidden>

            <!-- Import Button -->
            <button *ngIf="userRole === 'Admin User' || userRole === 'Factory User'" type="button"
              class="btn btn-teal-gradient btn-sm text d-flex align-items-center gap-1" (click)="fileInput.click()"
              [disabled]="isImporting">
              <i class="bi bi-upload"></i>
              Import
            </button>

            <!-- Add Button -->
            <button *ngIf="userRole === 'Admin User' || userRole === 'Factory User'" type="button"
              class="btn btn-teal-gradient btn-sm text d-flex align-items-center gap-1" (click)="handleFinishedClick()">
              <i class="bi bi-plus"></i>
              Add
            </button>
          </div>
        </div>

        <div class="d-flex align-items-center gap-2 mb-3" style="padding-top: 5px;">
          <div class="input-group" style="min-width: 30%">
            <span class="input-group-text"><i class="bi bi-search"></i></span>
            <input type="text" class="form-control" placeholder="Search Products..."
              [(ngModel)]="finishedGoodsSearchTerm" (input)="filterFinishedGoods()" />
          </div>

          <div class="filter-button-container">
            <button class="btn btn-teal-gradient btn-sm" [class.btn-teal-gradient]="!isFilterPanelOpenFinishedGoods"
              [class.btn-grey-gradient]="isFilterPanelOpenFinishedGoods" type="button"
              (click)="toggleFilterPanelFinishedGoods()">
              <i class="bi bi-funnel"></i>
              {{ !isFilterPanelOpenFinishedGoods ? 'Show Filters' : 'Hide Filters' }}
            </button>
          </div>
        </div>

        <div class="filter-panel-container">
          <div class="filter-panel" [class.visible]="isFilterPanelOpenFinishedGoods">
            <div class="d-flex align-items-center">
              <select class="form-select form-select-sm" [(ngModel)]="selectedCategoryFilter"
                (change)="filterFinishedGoods()">
                <option [ngValue]="null">All Categories</option>
                <option *ngFor="let category of categories" [ngValue]="category.categoryId">
                  {{ category.categoryName }}
                </option>
              </select>
            </div>
            <div class="d-flex align-items-center">
              <div class="d-flex align-items-center gap-2 w-100">
                <span class="text-muted me-2">Stock</span>
                <div class="btn-group segmented" role="group" aria-label="Finished goods stock filter">

                  <!-- All -->
                  <input type="radio" class="btn-check" name="fgStock" id="fg-stock-all" autocomplete="off"
                         [checked]="!NoProductStock && !WithProductStock"
                         (change)="NoProductStock=false; WithProductStock=false; filterFinishedGoods()">
                  <label class="btn segmented-btn"
                         [class.btn-teal-gradient]="!NoProductStock && !WithProductStock"
                         [class.btn-grey-gradient]="NoProductStock || WithProductStock"
                         for="fg-stock-all">
                    <i class="bi bi-collection me-1"></i> All
                  </label>

                  <!-- Low stock only -->
                  <input type="radio" class="btn-check" name="fgStock" id="fg-stock-low" autocomplete="off"
                         [checked]="NoProductStock && !WithProductStock"
                         (change)="NoProductStock=true; WithProductStock=false; filterFinishedGoods()">
                  <label class="btn segmented-btn"
                         [class.btn-teal-gradient]="NoProductStock && !WithProductStock"
                         [class.btn-grey-gradient]="!NoProductStock || WithProductStock"
                         for="fg-stock-low">
                    <i class="bi bi-exclamation-triangle me-1"></i> Low
                  </label>

                  <!-- In stock only -->
                  <input type="radio" class="btn-check" name="fgStock" id="fg-stock-in" autocomplete="off"
                         [checked]="!NoProductStock && WithProductStock"
                         (change)="NoProductStock=false; WithProductStock=true; filterFinishedGoods()">
                  <label class="btn segmented-btn"
                         [class.btn-teal-gradient]="!NoProductStock && WithProductStock"
                         [class.btn-grey-gradient]="NoProductStock || !WithProductStock"
                         for="fg-stock-in">
                    <i class="bi bi-check-circle me-1"></i> In stock
                  </label>

                </div>
              </div>
             </div>
            <div class="d-flex align-items-center mt-2">
              <div class="d-flex align-items-center gap-2 w-100 justify-content-end">
                <span class="text-muted me-1">Rows per page</span>
                <select class="form-select form-select-sm" style="max-width: 90px"
                        [(ngModel)]="finishedGoodsPageSize"
                        (ngModelChange)="finishedGoodsCurrentPage = 1">
                  <option [ngValue]="15">15</option>
                  <option [ngValue]="25">25</option>
                  <option [ngValue]="50">50</option>
                </select>
              </div>
            </div>
          </div>
        </div>




        <div class="table-responsive scrollable-content" style="flex-grow: 1; min-height: 0; overflow-y: auto">
          <!-- Search Bar for Finished Goods -->

          <div *ngIf="filteredFinishedGoods.length === 0" class="empty-state p-4 text-center">
            <div class="empty-state-icon mb-3">
              <i class="bi bi-bag-check" style="font-size: 2.5rem; color: #6c757d;"></i>
            </div>
            <h5 class="mb-2">No Products Found</h5>
            <p class="text-muted mb-0">Add your first Products to get started</p>
            <button class="btn btn-primary mt-3" (click)="handleFinishedClick()">
              <i class="bi bi-plus-circle me-1"></i> Add Products
            </button>
          </div>
          <!-- Desktop table for products -->
          <table class="table table-hover align-middle mb-0 d-none d-md-table" *ngIf="filteredFinishedGoods.length > 0">
            <thead class="table-header">
              <tr>
                <th class=" fw-bold" style="cursor: pointer" (click)="sortFinishedBy('itemCode')">
                  SKU
                  <i class="bi ms-1" [ngClass]="{
                        'bi-caret-down-fill':
                          finishedSortColumn !== 'itemCode' ||
                          (finishedSortColumn === 'itemCode' &&
                            finishedSortDirection === 'desc'),
                        'bi-caret-up-fill':
                          finishedSortColumn === 'itemCode' &&
                          finishedSortDirection === 'asc'
                      }"></i>
                </th>
                <th style="cursor: pointer" class="fw-bold" (click)="sortFinishedBy('itemName')">
                  Item Name
                  <i class="bi ms-1" [ngClass]="{
                        'bi-caret-down-fill':
                          finishedSortColumn !== 'itemName' ||
                          (finishedSortColumn === 'itemName' &&
                            finishedSortDirection === 'desc'),
                        'bi-caret-up-fill':
                          finishedSortColumn === 'itemName' &&
                          finishedSortDirection === 'asc'
                      }"></i>
                </th>
                <th style="cursor: pointer" class="fw-bold" (click)="sortFinishedBy('CategoryName')">
                  Category
                  <i class="bi ms-1" [ngClass]="{
                        'bi-caret-down-fill':
                          finishedSortColumn !== 'CategoryName' ||
                          (finishedSortColumn === 'CategoryName' &&
                            finishedSortDirection === 'desc'),
                        'bi-caret-up-fill':
                          finishedSortColumn === 'CategoryName' &&
                          finishedSortDirection === 'asc'
                      }"></i>
                </th>
                <th style="cursor: default" class="fw-bold">
                  Quantity
                </th>
                <th style="cursor: pointer" class="fw-bold" (click)="sortFinishedBy('sellingPrice')">
                  Selling Price
                  <i class="bi ms-1" [ngClass]="{
                        'bi-caret-down-fill':
                          finishedSortColumn !== 'sellingPrice' ||
                          (finishedSortColumn === 'sellingPrice' &&
                            finishedSortDirection === 'desc'),
                        'bi-caret-up-fill':
                          finishedSortColumn === 'sellingPrice' &&
                          finishedSortDirection === 'asc'
                      }"></i>
                </th>
                <th *ngIf="userRole === 'Admin User'" style="cursor: default" class="fw-bold text-center">
                  Actions
                </th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let item of finishedGoodsPaged">
                <td>{{ item.itemCode }}</td>
                <td class="fw-semibold">{{ item.itemName }}</td>
                <td>
                  <span class="category-badge" [style.background-color]="getCategoryColor(item.CategoryName)">
                    {{ item.CategoryName }}
                  </span>
                </td>
                <td>
                  <span class="quantity-badge badge-neutral">
                    {{ item.quantity }}
                  </span>
                </td>
                <td>{{ item.sellingPrice | currency : "ZAR" }}</td>
                <td *ngIf="userRole === 'Admin User'" class="text-nowrap">
                  <button *ngIf="userRole === 'Admin User'" class="btn-outline-primary" (click)="editItem(item)">
                    <i class="bi bi-pencil-square"></i>
                  </button>
                  <button *ngIf="userRole === 'Admin User'" class="btn-outline-primary danger"
                    (click)="selectedItem = item; showDeleteModal = true">
                    <i class="bi bi-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>


        </div>
      <nav *ngIf="filteredFinishedGoods.length > 0" class="mt-2" aria-label="Products pagination">
            <ul class="pagination pagination-sm mb-0 justify-content-end">
              <li class="page-item" [class.disabled]="finishedGoodsCurrentPage === 1">
                <button class="page-link" type="button" (click)="changeFinishedGoodsPage(finishedGoodsCurrentPage - 1)" aria-label="Previous">
                  <span aria-hidden="true">&laquo;</span>
                </button>
              </li>
              <li class="page-item" *ngFor="let page of finishedGoodsPages" [class.active]="page === finishedGoodsCurrentPage">
                <button class="page-link" type="button" (click)="changeFinishedGoodsPage(page)">{{ page }}</button>
              </li>
              <li class="page-item" [class.disabled]="finishedGoodsCurrentPage === finishedGoodsTotalPages">
                <button class="page-link" type="button" (click)="changeFinishedGoodsPage(finishedGoodsCurrentPage + 1)" aria-label="Next">
                  <span aria-hidden="true">&raquo;</span>
                </button>
              </li>
            </ul>
          </nav>
      </div>

    </div>

  </div>

  <div class="dashboard-cards fade-in d-none d-md-flex">
    <!-- Pie Chart Card -->
    <!-- <div class="metric-card chart-40" style="max-height: 80vh"> -->
      <div class="chart-container metric-card chart-40 " style="min-height: 80vh;height: calc(100% - 40px);">
        <app-pie-chart *ngIf="categoryLabels.length > 0 && categoryData.length > 0" [labels]="categoryLabels"
          [data]="categoryData" [title]="'Stock Distribution by Category'" [colors]="baseColors" [ItemsPerPage]="5">
        </app-pie-chart>
        <div *ngIf="categoryLabels.length === 0 || categoryData.length === 0"
          class="d-flex align-items-center justify-content-center h-100">
          <div class="text-center p-4">
            <i class="bi bi-pie-chart fs-1 text-muted mb-2"></i>
            <p class="mb-0">No data available for the pie chart</p>
            <small class="text-muted">Add inventory items with categories to see the distribution</small>
          </div>
        </div>
      </div>
    <!-- </div> -->

    <!-- Bar Chart Card -->
    <div class="metric-card chart-60" >
      <div class="chart-container" style="height: calc(100% - 40px);">
        <div *ngIf="stackedBarData && stackedBarData.labels && stackedBarData.labels.length > 0; else noBarData"
          class="h-100">


          <app-reuseable-bar-chart
            [title]="'Stock Value by Category'"
            [labels]="stackedBarData.labels"
            [data]="stackedBarData.datasets[0].data"
            [colors]="baseColors"
            [ItemsPerPage]="ItemsPerPage"
            [filters]="filters"
            [selectedFilter]="selectedFilter"
            [currentPage]="currentPage"
            [totalPages]="totalPages"
            [totalItemsCount]="totalItemsCount"
            [goToPage]="goToPage"
            [pageSizeChange]="onPageSizeChange"
            (filterChange)="onFilterChange($event)"
            (pageChange)="onPageChange($event)">
          </app-reuseable-bar-chart>
        </div>

        <ng-template #noBarData>
          <div class="d-flex align-items-center justify-content-center h-100">
            <div class="text-center p-4">
              <i class="bi bi-bar-chart fs-1 text-muted mb-2"></i>
              <p class="mb-0">No data available for the bar chart</p>
              <small class="text-muted">Add inventory items with categories to see the distribution</small>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<div class="d-none d-md-block">
  <app-alert
    [visible]="isAlertVisible"
    [title]="alertTitle"
    [message]="alertMessage"
    [alertbgcolor]="alertBgColor"
    [alerttextcolor]="alerttextcolor"
    (closed)="isAlertVisible = false">
  </app-alert>
</div>

<!-- In inventory-dashboard.component.html -->
<!-- Original Add/Edit Modal (for new items and editing) -->
<div class="modal-backdrop fade show" *ngIf="showAddModal && !isAddingQuantity"></div>

<div class="modal fade show" [class.d-block]="showAddModal && !isAddingQuantity" tabindex="-1"
  style="background-color: rgba(0, 0, 0, 0.5)">
  <div class="modal-dialog modal-xl modal-dialog-centered" style="width: 100%; max-width: 100vw; margin: 1.5rem">
    <div class="modal-content shadow-lg" style="
        max-height: calc(100vh - 3rem);
        display: flex;
        flex-direction: column;
        overflow: hidden;
        border: none;
        border-radius: 10px;
      ">
      <div class="modal-header"
        style="background: linear-gradient(to right, #1F7A8C, #107C8F) !important; border: none;">
        <div class="d-flex align-items-center justify-content-between w-100">
          <!-- Left Section: Icon and Title -->
          <div class="d-flex align-items-center">
            <div class="section-icon me-2" style="
          background: rgba(255, 255, 255, 0.2);
          width: 36px;
          height: 36px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
        ">
              <i class="bi bi-box text-white"></i>
            </div>
            <h5 class="modal-title text-white fw-bold m-0">
              {{ isEditing ? "Edit" : "Add" }} {{ isFinishedGood ? 'Product' : 'Raw Material' }}
            </h5>
          </div>

          <!-- Right Section: Close Button -->
          <button type="button" class="close-button"
            (click)="showAddModal = false; inventoryForm.reset(); supplierForm.reset(); categoryForm.reset();">×</button>
        </div>
      </div>
      <div class="modal-body">
        <!-- Supplier Section (Only shown for Raw Materials) -->
<div class="form-section supplier-section mb-4" *ngIf="!isFinishedGood">
          <div class="section-header">
            <h5 class="section-title">
              Supplier Information
            </h5>
          </div>

          <div class="form-tabs mb-3">
            <div class="nav" role="tablist">
              <button class="nav-link" [class.active]="!isCreatingSupplier"
                [ngClass]="{'tab-selected': !isCreatingSupplier}" (click)="isCreatingSupplier = false">
                <i class="bi bi-list-ul me-2"></i>Select Existing Supplier
              </button>
              <button type="button"
              class="nav-link"
              (click)="navigateToAddSupplier()">
        <i class="bi bi-plus-circle me-2"></i> Add Suppliers
      </button>
              <!-- <button class="nav-link" [class.active]="isCreatingSupplier"
        [ngClass]="{'tab-selected': isCreatingSupplier}" (click)="isCreatingSupplier = true">
        <i class="bi bi-plus-circle me-2"></i>Create New Supplier
      </button> -->
            </div>
          </div>

          <div *ngIf="!isCreatingSupplier" class="mb-3">
            <div class="form-group">
              <app-single-select-dropdown
                [options]="desktopSupplierOptions"
                [selectedValue]="selectedSupplier ? String(selectedSupplier.supplierID) : null"
                placeholder="Select a supplier"
                (selectedValueChange)="onDesktopSupplierSelected($event)">
              </app-single-select-dropdown>
            </div>
          </div>
          <form *ngIf="isCreatingSupplier" [formGroup]="supplierForm" class="row g-3">
            <!-- Supplier form fields here -->
          </form>
        </div>

        <!-- Category Section -->
        <div class="form-section category-section mb-4">
          <div class="section-header">
            <h5 class="section-title">
              Category Information
            </h5>
          </div>

          <div class="form-tabs mb-3">
            <div class="nav" role="tablist">
              <button class="nav-link" [class.active]="!isCreatingCategory"
                [ngClass]="{'tab-selected': !isCreatingCategory}" (click)="isCreatingCategory = false">
                <i class="bi bi-list-ul me-2"></i>Select Existing Category
              </button>

              <button class="nav-link" [class.active]="isCreatingCategory"
                [ngClass]="{'tab-selected': isCreatingCategory}" (click)="isCreatingCategory = true">
                <i class="bi bi-plus-circle me-2"></i>Add Category
              </button>
            </div>
          </div>

          <div *ngIf="!isCreatingCategory" class="mb-3">
            <div class="form-group">
              <app-single-select-dropdown
                [options]="desktopCategoryOptions"
                [selectedValue]="selectedCategory ? String(selectedCategory.categoryId) : null"
                placeholder="Select a category"
                (selectedValueChange)="onDesktopCategorySelected($event)">
              </app-single-select-dropdown>
            </div>
          </div>

          <form *ngIf="isCreatingCategory" [formGroup]="categoryForm" class="row g-3">
            <div class="col-md-6">
              <div class="form-group">
                <label class="form-label">Category Name</label>
                <div class="input-group">
                  <span class="input-group-text bg-transparent border-end-0">
                    <i class="bi bi-tag text-secondary"></i>
                  </span>
                  <input type="text" class="form-control border-start-0" formControlName="categoryName" />
                </div>
              </div>
            </div>
            <div class="col-12 mt-3 d-flex justify-content-end">
              <button class="btn btn-gradient-primary" (click)="createCategory()">
                <i class="bi bi-plus-circle"></i>
                <span>Create Category</span>
              </button>
            </div>
          </form>

        </div>

        <!-- Item Details Section -->
        <div class="form-section item-section mb-4" *ngIf="
    (isFinishedGood && selectedCategory) ||
    (!isFinishedGood && selectedSupplier && selectedCategory)
  ">
<div class="section-header d-flex justify-content-between align-items-center mb-3">
  <h5 class="section-title mb-0">Item Details</h5>
  <button type="button"
          class="btn btn-gradient-primary btn-sm"
          *ngIf="isEditing && !isFinishedGood"
          (click)="togglePurchaseFields()">
    <i class="bi" [class.bi-pencil]="!showPurchaseFields" [class.bi-x]="showPurchaseFields"></i>
    {{ showPurchaseFields ? 'Cancel Update' : 'Update Purchase Price' }}
  </button>
</div>

          <form [formGroup]="inventoryForm" class="row g-3">
            <div class="col-md-6">
              <div class="form-group">
                <label class="form-label">Item Name</label>
                <div class="input-group">
                  <span class="input-group-text bg-transparent border-end-0">
                    <i class="bi bi-box2 text-secondary"></i>
                  </span>
                  <input type="text" class="form-control border-start-0" formControlName="itemName" />
                </div>
              </div>
            </div>
            <!-- <div class="col-md-6">
      <div class="form-group">
        <label class="form-label">Description</label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0">
            <i class="bi bi-text text-secondary"></i>
          </span>
          <input type="text" class="form-control border-start-0" formControlName="description" />
        </div>
      </div>
    </div> -->
    <div class="col-md-6" *ngIf="!isFinishedGood">
      <div class="form-group">
        <label class="form-label">Reorder Level</label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0">
            <i class="bi bi-arrow-repeat text-secondary"></i>
          </span>
          <input type="number" class="form-control border-start-0" formControlName="lowStockThreshold" />
        </div>
      </div>
    </div>
    <!-- Purchase Price (Add mode for Raw Materials) -->
    <div class="col-md-6" *ngIf="!isFinishedGood && !isEditing">
      <div class="form-group">
        <label class="form-label">Purchase Price</label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0">
            <i class="text-secondary fw-bold">R</i>
          </span>
          <input type="number" class="form-control border-start-0" formControlName="purchasePrice" step="0.01" min="0" appNumericInput />
        </div>
        <div class="text-danger small mt-1" *ngIf="purchasePriceError">{{ purchasePriceError }}</div>
      </div>
    </div>
    <div class="row" *ngIf="showPurchaseFields && isEditing && !isFinishedGood">
      <div class="alert alert-info p-3 mb-3" *ngIf="isEditing && !isFinishedGood && showPurchaseFields">
        <div class="d-flex align-items-center">
          <i class="bi bi-info-circle me-2 fs-5"></i>
          <div>
            <h6 class="mb-1 fw-semibold">Update Purchase Details</h6>
            <p class="mb-1 small">Please enter the new purchase price and quantity for this item. These values will be used to calculate the updated unit cost.</p>
            <p class="mb-0 small text-muted"><i class="bi bi-info-circle me-1"></i> Note: The quantity entered will be added to your current stock level.</p>
          </div>
        </div>
      </div>
    <div class="col-md-6">

      <div class="form-group">
        <label class="form-label">New Purchase Price</label>
        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0">
            <i class="text-secondary fw-bold">R</i>
          </span>
          <input type="number" class="form-control border-start-0" formControlName="purchasePrice" step="0.01" min="0" appNumericInput />
        </div>
        <div class="text-danger small mt-1" *ngIf="purchasePriceError">{{ purchasePriceError }}</div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label class="form-label">New Purchase Quantity</label>

        <div class="input-group">
          <span class="input-group-text bg-transparent border-end-0">
            <i class="bi bi-123 text-secondary"></i>
          </span>
          <input type="number" class="form-control" formControlName="quantityToAdd" min="1" />

        </div>
      </div>
    </div>
  </div>
            <div class="col-md-6" *ngIf="!isFinishedGood && !isEditing">
              <div class="form-group">
                <label class="form-label">Unit Cost</label>
                <div class="input-group">
                  <span class="input-group-text bg-transparent border-end-0">
                    <i class="text-secondary fw-bold">R</i>
                  </span>
                  <input type="number" class="form-control border-start-0" formControlName="unitCost" step="0.01"
                    min="0" [readonly]="!isEditing && !isAddingQuantity"  />
                </div>
                <small class="text-muted" style="margin-left: 5px;">Calculated by dividing purchase price with initial quantity</small>
              </div>
            </div>
            <div class="col-md-6" *ngIf="isFinishedGood">
              <div class="form-group">
                <label class="form-label">Selling Price</label>
                <div class="input-group">
                  <span class="input-group-text bg-transparent border-end-0">
                    <i class="text-secondary fw-bold">R</i>
                  </span>
                  <input type="number" class="form-control border-start-0" formControlName="sellingPrice" />
                </div>
              </div>
            </div>

            <div class="col-md-6" *ngIf="!isFinishedGood && !isEditing">
              <div class="form-group">
                <label class="form-label">Initial Quantity</label>
                <div class="input-group">
                  <span class="input-group-text bg-transparent border-end-0">
                    <i class="bi bi-123 text-secondary"></i>
                  </span>
                  <app-area-quantity-input
                    [uomCode]="getSelectedUomCode()"
                    [value]="inventoryForm.get('quantityToAdd')?.value ?? 0"
                    (valueChange)="setQuantityToAdd($event)"
                    cssClass="form-control border-start-0"
                  />
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label class="form-label">SKU</label>
                <div class="input-group">
                  <span class="input-group-text bg-transparent border-end-0">
                    <i class="bi bi-upc-scan text-secondary"></i>
                  </span>
                  <input type="text" class="form-control border-start-0" formControlName="itemCode" />
                </div>
                <small class="text-muted">Leave blank to auto-generate</small>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label class="form-label">Unit of Measure</label>
                <div class="input-group">
                  <span class="input-group-text bg-transparent border-end-0">
                    <i class="bi bi-box2 text-secondary"></i>
                  </span>
                  <select class="form-control border-start-0" formControlName="PurchaseUOMID"
                    [compareWith]="compareUOM">
                    <option [ngValue]="null" disabled>Select Unit of Measure</option>
                    <option *ngFor="let uom of uomList" [ngValue]="uom.uomid">
                     {{ uom.uomName }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

          </form>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeAddModal()">Cancel</button>
        <button type="button" class="btn btn-gradient-primary" (click)="saveItem()">
          <i class="bi bi-check2-circle"></i>
          <span>{{ isEditing ? "Update" : "Add" }} Item</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Simplified Quantity-Only Modal (only for adding quantity to existing items) -->
<div *ngIf="showAddModal && isAddingQuantity" class="modal-backdrop" (click)="closeAddModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">Add Quantity</h2>
      <button type="button" class="close-button" (click)="closeAddModal()">×</button>
    </div>
    <form [formGroup]="inventoryForm">
      <div class="modal-body">
        <!-- Item Details (Readonly) -->
        <div class="mb-4">
          <div class="form-group">
            <label class="form-label">Item Name</label>
            <div class="form-control-plaintext">{{inventoryForm.get('itemName')?.value}}</div>
          </div>
          <div class="form-group">
            <label class="form-label">Current Quantity</label>
            <div class="form-control-plaintext">{{inventoryForm.get('currentQuantity')?.value || 0}}</div>
          </div>
        </div>

        <!-- Quantity to Add -->
        <div class="form-group">
          <label class="form-label">Quantity to Add</label>
          <div class="input-group">
            <span class="input-group-text bg-transparent border-end-0">
              <i class="bi bi-plus-circle text-secondary"></i>
            </span>
            <input type="number" class="form-control border-start-0" formControlName="quantityToAdd" min="1" step="1"
              required />
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeAddModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="addQuantityToItem()">Add Quantity</button>
      </div>
    </form>
  </div>
</div>

<!-- Import Progress Modal -->
<div class="modal fade" id="importProgressModal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static"
  [class.show]="isImporting" [style.display]="isImporting ? 'block' : 'none'" [attr.aria-hidden]="!isImporting">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content border-0 shadow">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title d-flex align-items-center">
          <i class="bi bi-upload me-2"></i>
          Importing Items
        </h5>
      </div>
      <div class="modal-body p-4">
        <div class="d-flex justify-content-center mb-3">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <h6 class="text-center mb-3">Processing your import...</h6>

        <div class="progress mb-4" style="height: 10px; border-radius: 5px;">
          <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" role="progressbar"
            [style.width]="importProgress + '%'" [attr.aria-valuenow]="importProgress" aria-valuemin="0"
            aria-valuemax="100">
            <span class="visually-hidden">{{ importProgress }}% Complete</span>
          </div>
        </div>

        <div class="d-flex justify-content-between mb-2">
          <small class="text-muted">Progress</small>
          <small class="fw-bold">{{ importProgress }}%</small>
        </div>

        <div class="text-center mt-4">
          <p class="small text-muted mb-0">
            <i class="bi bi-info-circle me-1"></i>
            Please do not close this window while the import is in progress.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Error Details Modal -->
<div class="modal fade" id="errorDetailsModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content border-0 shadow">
      <div class="modal-header bg-danger text-white">
        <h5 class="modal-title d-flex align-items-center">
          <i class="bi bi-exclamation-triangle-fill me-2"></i>
          Import Results
        </h5>
        <button type="button" class="close-button" data-bs-dismiss="modal" aria-label="Close">x</button>
      </div>
      <div class="modal-body p-4">


        <div *ngIf="importResults.errors.length > 0" class="mt-4">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="mb-0">
              <i class="bi bi-exclamation-triangle text-warning me-2"></i>
              Import Issues ({{ importResults.errors.length }})
            </h6>
            <span class="badge bg-danger">{{ importResults.errors.length }} error{{ importResults.errors.length !== 1 ?
              's' : '' }}</span>
          </div>

          <div class="table-responsive">
            <table class="table table-sm table-hover align-middle">
              <thead class="table-light">
                <tr>
                  <th>Row</th>
                  <th class="w-25">Item</th>
                  <th>Value</th>
                  <th>Error Details</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let error of importResults.errors; let i = index" [attr.data-testid]="'error-row-' + i"
                  class="border-start border-4 border-danger">
                  <td>{{ error.rowIndex }}</td>
                  <td class="fw-semibold">

                    <div class="d-flex align-items-center">
                      <i class="bi bi-x-circle-fill text-danger me-2"></i>
                      {{ error.item['itemname*'] || 'Unknown Item' }}
                    </div>
                  </td>
                  <td class="text-muted small">{{ error.item['purchaseprice*'] || error.item['purchaseprice'] || '' }}</td>
                  <td>
                    <span class="badge bg-danger bg-opacity-10" style="color: white;">
                      {{ error.error }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div *ngIf="(importResults.warnings?.length ?? 0) > 0" class="mt-4">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h6 class="mb-0">
              <i class="bi bi-info-circle text-warning me-2"></i>
              Needs Review ({{ importResults.warnings.length }})
            </h6>
            <span class="badge bg-warning text-dark">{{ importResults.warnings.length }} warning{{
              importResults.warnings.length !== 1 ? 's' : '' }}</span>
          </div>

          <div class="table-responsive">
            <table class="table table-sm table-hover align-middle">
              <thead class="table-light">
                <tr>
                  <th>Row</th>
                  <th class="w-25">Item</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let warning of importResults.warnings; let i = index"
                  [attr.data-testid]="'warning-row-' + i" class="border-start border-4 border-warning">
                  <td>{{ warning.rowIndex }}</td>
                  <td class="fw-semibold">
                    <div class="d-flex align-items-center">
                      <i class="bi bi-exclamation-circle-fill text-warning me-2"></i>
                      {{ warning.item['itemname*'] || 'Unknown Item' }}
                    </div>
                  </td>
                  <td>
                    <span class="badge bg-warning bg-opacity-25 text-dark">
                      {{ warning.warning }} — imported, please review
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button *ngIf="hasRawMaterialErrors()" type="button" class="btn btn-primary" data-bs-dismiss="modal"
          (click)="downloadFailedRawMaterials()">
          <i class="bi bi-download"></i> Download Failed Raw Materials
        </button>
        <button *ngIf="hasFinishedGoodErrors()" type="button" class="btn btn-primary" data-bs-dismiss="modal"
          (click)="downloadFailedFinishedGoods()">
          <i class="bi bi-download"></i> Download Failed Finished Goods
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Add Option Modal -->
<div *ngIf="showAddOptionModal" class="modal-backdrop" (click)="showAddOptionModal = false">
  <div class="modal-content " (click)="$event.stopPropagation()">
    <div class="modal-header p-3">
      <h2>Add {{ isFinishedGood ? 'Stock / Goods' : 'Ingredients / Materials' }}</h2>
      <button type="button" class="close-button" (click)="showAddOptionModal = false">×</button>
    </div>
    <div class="button-group p-3 d-flex justify-content-center">
      <button class="btn btn-primary me-2" (click)="selectAddOption('new')">Add New Item</button>
      <button class="btn btn-primary" (click)="selectAddOption('existing')">Add Quantity to Existing Item</button>
    </div>
  </div>
</div>

<!-- Item Selection Modal -->
<div *ngIf="showItemSelectModal" class="modal-backdrop" (click)="closeItemSelectModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Select Item</h2>
      <button type="button" class="close-button" (click)="closeItemSelectModal()">x</button>
    </div>
    <div class="search-bar p-3 d-flex justify-content-center">
      <div class="input-group" style="min-width: 30%">
        <span class="input-group-text"><i class="bi bi-search"></i></span>
        <input type="text" class="form-control" placeholder="Search Items..." [(ngModel)]="rawMaterialsSearchTerm"
          (input)="filterRawMaterials()" />
      </div>
    </div>

    <div class="p-3 items-list">
      <div *ngFor="let item of rawMaterials" class="item-card" (click)="selectItemForQuantityAdd(item)">
        <div class="item-info">
          <div class="item-name">{{ item.itemName }}</div>
          <div class="item-details">
            <span>SKU: {{ item.itemCode }}</span>
            <span>Current Quantity: {{ item.quantity }}</span>
          </div>
        </div>
      </div>
      <button class="btn btn-secondary" (click)="closeItemSelectModal()">Cancel</button>
    </div>

  </div>

</div>

<!-- Low Stock Popup — desktop only -->
<div *ngIf="lowStockItems !== 0 && showLowStockPopup" class="modal-backdrop inv-low-stock-desktop">
  <div class="modal-content">
    <div class="modal-header">
      <h4>Low Stock Items</h4>
      <button type="button" class="close-button" (click)="closeLowStockPopup()">x</button>
    </div>
    <div class="modal-body">
      <h4>The following items are low in stock:</h4>
      <div
        style="margin-bottom: 10px; border: 1px solid #dee2e6; padding: 10px; border-radius: 5px; box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);"
        *ngFor="let item of lowStockItemsList">
        <h5 style="margin-bottom: 5px; background-color: #107C8F; padding: 5px; border-radius: 5px;color: white;">
          {{item.name}}</h5>
        <h5 style="margin-bottom: 5px;">Has <span style="color: red;">{{item.quantity}}</span> remaining (Reorder at: {{
          item.threshold }})</h5>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-primary" (click)="closeLowStockPopup()">Close</button>
    </div>
  </div>
</div>

<!-- Low Stock Offcanvas — mobile only -->
<div *ngIf="lowStockItems !== 0 && showLowStockPopup" class="inv-offcanvas-backdrop d-md-none" (click)="closeLowStockPopup()">
  <div class="inv-offcanvas-sheet" (click)="$event.stopPropagation()">
    <div class="inv-sheet-handle-bar">
      <div class="inv-sheet-handle"></div>
    </div>
    <div class="inv-sheet-header">
      <div class="d-flex align-items-center gap-2">
        <i class="bi bi-exclamation-triangle-fill text-warning fs-5"></i>
        <span class="inv-sheet-title">Low Stock Items</span>
      </div>
      <button class="inv-sheet-close" (click)="closeLowStockPopup()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
    <div class="inv-sheet-body">
      <p class="text-muted small mb-3">The following items are running low and need restocking:</p>
      <div class="inv-low-stock-card" *ngFor="let item of lowStockItemsList">
        <div class="inv-low-stock-name">{{ item.name }}</div>
        <div class="inv-low-stock-detail">
          <span class="inv-low-stock-qty">{{ item.quantity }} remaining</span>
          <span class="inv-low-stock-threshold">Reorder at: {{ item.threshold }}</span>
        </div>
      </div>
      <button class="inv-sheet-close-btn mt-3" (click)="closeLowStockPopup()">Dismiss</button>
    </div>
  </div>
</div>


<!-- Reorder Level Prompt — mobile (bottom-sheet) -->
<div class="d-md-none">
  <app-offcanvas-sheet
    [visible]="showReorderPrompt"
    title="Set Reorder Levels"
    cancelLabel="Skip for Now"
    saveLabel="Save Levels"
    (closeCanvas)="closeReorderPrompt()"
    (save)="saveReorderLevels()">
    <p class="text-muted small mb-2">These items have no reorder level set. Setting one helps you get notified when stock runs low.</p>
    <div *ngFor="let item of zeroReorderItems" class="form-group-mobile">
      <label class="form-label fw-semibold">{{ item.itemName }}</label>
      <div class="input-group">
        <input type="number" class="form-control" [(ngModel)]="reorderEditValues[item.itemID]" min="0" placeholder="Reorder at" />
        <span class="input-group-text">{{ getUOMName(item.purchaseUOMID) || 'units' }}</span>
      </div>
    </div>
  </app-offcanvas-sheet>
</div>

<!-- Reorder Level Prompt — desktop (centred modal) -->
<div *ngIf="showReorderPrompt" class="d-none d-md-block">
  <div class="modal-backdrop" (click)="closeReorderPrompt()">
    <div class="modal-content" (click)="$event.stopPropagation()" style="max-width: 500px;">
      <div class="modal-header">
        <h4>Set Reorder Levels</h4>
        <button type="button" class="close-button" (click)="closeReorderPrompt()">x</button>
      </div>
      <div class="modal-body">
        <p class="text-muted mb-3">The following items have no reorder level set. Setting a reorder level helps you get notified when stock runs low.</p>
        <div *ngFor="let item of zeroReorderItems"
          style="margin-bottom: 10px; border: 1px solid #dee2e6; padding: 10px; border-radius: 5px;">
          <div class="d-flex justify-content-between align-items-center">
            <span class="fw-semibold">{{ item.itemName }}</span>
            <div class="input-group" style="max-width: 200px;">
              <input type="number" class="form-control form-control-sm"
                [(ngModel)]="reorderEditValues[item.itemID]" min="0" placeholder="Reorder at" />
              <span class="input-group-text input-group-text-sm">{{ getUOMName(item.purchaseUOMID) || 'units' }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-secondary" (click)="closeReorderPrompt()">Skip for Now</button>
        <button class="btn btn-primary" (click)="saveReorderLevels()">Save Reorder Levels</button>
      </div>
    </div>
  </div>
</div>

<!-- Delete Modal -->
<div *ngIf="showDeleteModal && selectedItem" class="modal-backdrop" (click)="showDeleteModal = false">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Delete {{ selectedItem.itemTypeID === 2 ? 'Stock / Goods' : 'Ingredients / Materials' }}

      </h2>
      <button type="button" class="close-button" (click)="showDeleteModal = false">x</button>
    </div>
    <div class="modal-body">
      <p> Are you sure you want to delete this {{ selectedItem.itemTypeID === 2 ? 'stock / goods' : 'ingredient /material' }}?</p>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="showDeleteModal = false">Cancel</button>
      <button class="btn btn-danger" (click)="selectedItem && deleteItem(selectedItem)">Delete</button>
    </div>
  </div>
</div>
<div *ngIf="isLoading" class="app-spinner-overlay">
  <div class="app-loading-spinner"></div>
</div>
